import { render, staticRenderFns } from "./WhiteLoginUser.vue?vue&type=template&id=1516c0d2&scoped=true&"
import script from "./WhiteLoginUser.vue?vue&type=script&lang=js&"
export * from "./WhiteLoginUser.vue?vue&type=script&lang=js&"
import style0 from "./WhiteLoginUser.vue?vue&type=style&index=0&id=1516c0d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516c0d2",
  null
  
)

export default component.exports